import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { SlideFormat } from "../SlideFormat";

/** アップロード完了を確定する (uploading → ready)。`name` でリネーム可。 */
export async function commitSlideFormat(
    formatId: string,
    patch: { name?: string } = {}
): Promise<SlideFormat> {
    const res = await fetchWithAuth(`/slide-formats/${formatId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(patch),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "スライドフォーマットの確定に失敗しました");
    const body = (await res.json()) as { slideFormat: SlideFormat };
    return body.slideFormat;
}
